import React from 'react';

export default function CostEstimateDialog({ isOpen, onClose, onConfirm, estimate, isLoading }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <div className="flex items-center gap-2 mb-4">
          <span className="text-yellow-500 text-xl">⚠</span>
          <h2 className="text-xl font-semibold">Confirm Pricing Configuration</h2>
        </div>

        {isLoading ? (
          <div className="text-center py-8">
            <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
            <p className="mt-2 text-gray-600">Calculating estimates...</p>
          </div>
        ) : estimate ? (
          <>
            <p className="text-gray-600 mb-4">Your configuration will result in approximately:</p>

            <div className="bg-blue-50 rounded-lg p-4 text-center mb-4">
              <div className="text-3xl font-bold text-blue-600">~{estimate.total_estimate}</div>
              <div className="text-sm text-gray-600">LLM calls per stop combination</div>
              <div className="text-xs text-gray-500">over {estimate.forecast_days} days</div>
            </div>

            {estimate.breakdown && (
              <table className="w-full text-sm mb-4">
                <thead>
                  <tr className="text-left text-gray-500 border-b">
                    <th className="pb-2">Tier</th>
                    <th className="pb-2">Days</th>
                    <th className="pb-2">Interval</th>
                    <th className="pb-2 text-right">Calls</th>
                  </tr>
                </thead>
                <tbody>
                  {estimate.breakdown.map((row, i) => (
                    <tr key={i} className="border-b last:border-0">
                      <td className="py-1">{row.tier}</td>
                      <td className="py-1">{row.days}</td>
                      <td className="py-1">{row.interval}</td>
                      <td className="py-1 text-right">{row.calls}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            <p className="text-xs text-gray-500 mb-4">{estimate.note}</p>
          </>
        ) : (
          <p className="text-gray-600 mb-4">Unable to calculate estimate.</p>
        )}

        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 border rounded hover:bg-gray-50">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
          >
            Apply Configuration
          </button>
        </div>
      </div>
    </div>
  );
}
